import styles from "./YuJaToggle.module.css";
import {useEffect, useRef, useState} from "react";
import {BUTTON} from "../../utils/constants";
import { useTranslation } from "react-i18next";
import {YuJaTooltip} from "./YuJaTooltip";


export const YuJaToggle = ({
                               toggled=false,
                               ariaLabel,
                               onClick,
                               label=true,
                               disabled=false,
                               disabledReason,
                               enabledText="",
                               disabledText="",
                               containerStyle={},
                               ...props
}) => {
    const { t } = useTranslation();
    const [inputVal, setInputVal] = useState(toggled);
    const actualInputBoxRef = useRef(null);
    const onClickEvent = (e) => {
        if (disabled) {
            return
        }

        const box = actualInputBoxRef.current;
        if (box) {
            box.click();
        }
    }

    const onChangeFunc = (e) => {
        // setInputVal(e.target.checked);
        if (onClick) {
            onClick(e);
        }
    }

    useEffect(() => {
        setInputVal( toggled);
    }, [toggled]);

    return (
        <div className={styles.container} style={containerStyle}>
            {!!label &&
                <span className={styles.label}>
                    {!!inputVal
                        ? (!!enabledText ? enabledText : t("questionBuilder.enabledText"))
                        : (!!disabledText ? disabledText : t("questionBuilder.disabledText"))
                    }
                </span>
            }

            <div
                tabIndex={disabled ? -1 : 0}
                className={styles.toggleContainer}
                onClick={onClickEvent}
                role={BUTTON}
                {...props}
            >
                <input ref={actualInputBoxRef} name={props.name} className={styles.actualCheckBox} type={"checkbox"}
                       aria-label={ariaLabel}
                       checked={inputVal} onChange={onChangeFunc} disabled={disabled}/>
                <span className={styles.backgroundWrapper}/>
            </div>
        </div>

    )
}